export default "__VITE_ASSET__BD9XzVmA__"